const englishRegionNames = new Intl.DisplayNames(['en'], { type: 'region' });

export const translateCountryCode = (countryCode) =>
  countryCode ? englishRegionNames.of(countryCode) : '';
